import { FieldTemplate } from '../../../app/components/fields-template/field-template';
import { BaseTemplate } from './base';
import { BlastTemplate } from './blast';
import { InventorizeTemplate } from './inventorize';
import { MarkingsTemplate } from './markings';
import { WipeTemplate } from './wipe';
import { WorkplaceTemplate } from './workplace';

/** Maps an entity-type key to a FieldTemplate instance. */
export const TEMPLATE_MAP: Record<string, FieldTemplate> = {
    base: new BaseTemplate(),
    blast: new BlastTemplate(),
    markings: new MarkingsTemplate(),
    wipe: new WipeTemplate(),
    inventorize: new InventorizeTemplate(),
    workplace: new WorkplaceTemplate(),
};
